<template>
    <div class="mylistwrap" v-if="isload" @click="moreshow()">
        <div v-if="($common.basic.isarrayexist(infolist))" class="mylist">

            <dl class="avg listheader" v-if="!issmall">
                <dd>{{$common.dicword('infoclass')}}</dd>
                <dd> {{$common.dicword('datebegin')}} </dd>
                <dd>{{$common.dicword('dateend')}}</dd>
                <dd>{{$common.dicword('classteacher')}}</dd>
                <dd>{{$common.dicword('courselevel')}}</dd>

            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="(item,index) in infolist" :key="item.id">
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('infoclass',true)}}&nbsp;
                        </span>
                        {{$common.langinfo(item.title,item.title_en)}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('datebegin',true)}}&nbsp;
                        </span>
                        {{$common.basic.dateformat(item.datebegin)}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('dateend',true)}}&nbsp;
                        </span>
                        {{$common.basic.dateformat(item.dateend)}}
                    </dd>
                    <dd class="ztwrap">
                        <template v-if="issmall">
                            <span class="smalltitle">
                                {{$common.dicword('classteacher',true)}} &nbsp;
                            </span>
                            <span class="overdot">
                                <font v-for="(item2,index2) in item.x_cts" :key="index2">
                                    {{item2.showname||item2.reslname||item2.username}}
                                </font>

                            </span>
                        </template>
                        <template v-else>
                            <span :class="[item.x_ctshow?'ztshow':'zt']" @mouseover="item.x_ctshow=item.x_cts.length>1" @mouseout="item.x_ctshow=false">

                                <span v-for="(item2,index2) in item.x_cts" :key="index2">
                                    {{item2.showname||item2.reslname||item2.username}}
                                    <i v-if="!item.x_ctshow" :class="[(item.x_cts.length>1 && index2==0)?'iconfont icon-shiyuanjiaosanjiao':'iconfont']" @click.stop.prevent="moreshow(-1,index)"></i>
                                </span>
                            </span>
                        </template>
                    </dd>
                    <dd class="ztwrap">

                        <template v-if="issmall">
                            <span class="smalltitle">
                                {{$common.dicword('courselevel',true)}} &nbsp;
                            </span>
                            <span class="overdot">
                                <font v-for="(item2,index2) in item.x_levels" :key="index2">
                                    {{$common.langinfo(item2.title,item2.title_en)}}
                                </font>

                            </span>
                        </template>
                        <template v-else>
                            <span :class="[item.x_levelshow?'ztshow':'zt']" @mouseover="item.x_levelshow=item.x_levels.length>1" @mouseout="item.x_levelshow=false">

                                <span v-for="(item2,index2) in item.x_levels" :key="index2">
                                    <ffoverdot :title="item2.title" :title_en="item2.title_en" :needtitle="true"></ffoverdot>
                                    <i v-if="!item.x_levelshow" :class="[(item.x_levels.length>1 && index2==0)?'iconfont icon-shiyuanjiaosanjiao':'iconfont']" @click.stop.prevent="moreshow(index)"></i>
                                </span>
                            </span>
                        </template>

                    </dd>

                </dl>
            </div>

            <div class="ffpage">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>
        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
    </div>
</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin"
    export default {
        name: 'Cgroup',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tea_t_group'
            };
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {

                    this.$common.each(res.infodata, item => {
                        let levelids = item.levelids.split(',');
                        let _levels = [];
                        this.$common.each(levelids, (item) => {
                            let clevel = this.$common.basic.fffind(res.infodatalevel, 'id', item);
                            if (this.$common.basic.isobjexist(clevel)) {
                                _levels.push(clevel);
                            }
                        });
                        item.x_levels = _levels;
                        item.x_levelshow = false;
                    });


                    this.$common.each(res.infodata, item => {
                        let ctids = item.ctids.split(',');
                        let _cts = [];
                        this.$common.each(ctids, (item) => {
                            let cct = this.$common.basic.fffind(res.infodatact, 'id', item);
                            if (this.$common.basic.isobjexist(cct)) {
                                _cts.push(cct);
                            }
                        });
                        item.x_cts = _cts;
                        item.x_ctshow = false;
                    });

                    this.infolist = res.infodata;
                    this.res = res;

                    this.isload = true;
                });
            },
            moreshow: function (v1, v2 = -1) {
                this.$common.each(this.infolist, (item, index) => {
                    if (v1 == index) {
                        item.x_levelshow = !item.x_levelshow;
                        item.x_ctshow = false;
                    }
                    else if (v2 == index) {
                        item.x_levelshow = false;
                        item.x_ctshow = !item.x_ctshow;
                    }
                    else {
                        item.x_levelshow = false;
                        item.x_ctshow = false;
                    }
                });
            }
        }
    }

</script>
